import styled from "styled-components";

export const AccordionContainer = styled.div`
  width: 70%;
  height: 388px;
  @media (max-width: 1024px) {
    width: 100%;
    /* min-height: 500px;
    max-height: max-content; */
    margin-bottom: 6rem;
  }
  @media (max-width: 600px) {
    margin-bottom: 40px;
  }
`;

export const AccordionWrapper = styled.div`
  margin-bottom: 6rem;
  @media (max-width: 1024px) {
    width: 100%;
    margin-bottom: 0;
  }
`;

export const Wrapper = styled.div`
  /* width: 80%; */
  padding: 1rem 1rem 4rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  margin-top: 2rem;
  @media (max-width: 1024px) {
    width: 100%;
  }
  :last-child {
    border: none;
    @media (max-width: 1024px) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  h2 {
    font-size: 2rem;
    font-weight: 700;
    color: var(--title-color);
    line-height: 3.2rem;
    margin-bottom: 1.2rem;
    font-family: Peyda;
    @media (max-width: 480px) {
      font-size: 1.4rem;
      margin-bottom: 1rem;
    }
  }
  .icon-wrapper {
    width: 20px;
    height: 20px;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    border: 1.5px solid #292d32;
    border-radius: 1px;
    justify-content: center;
    cursor: pointer;
    transition: 0.7s;
    @media (max-width: 600px) {
      width: 24px;
      height: 24px;
    }
    @media (max-width: 525px) {
      width: 18px;
      height: 18px;
    }
    &.show {
      border: 1.5px solid var(--primary-color);
      color: var(--primary-color);
      transition: 0.7s;
    }
  }
`;
export const ContentWrapper = styled.div`
  &.content {
    font-size: 1.6rem;
    max-height: 0;
    overflow: hidden;
    font-weight: 400;
    font-family: Peyda;
    line-height: 3.2rem;
    width: 830px;
    color: var(--span-color);
    transition: all 0.7s cubic-bezier(0, 1, 0, 1);

    @media (max-width: 1350px) {
      width: 100%;
    }
    @media (max-width: 480px) {
      font-size: 1.4rem;
      line-height: 2rem;
    }
  }
  &.content.show {
    max-height: 9999px;
    transition: all 0.7s cubic-bezier(1, 0, 1, 0);
  }
`;
